import React from "react";
import { HeaderAction, HeaderState } from "../../types";
import ButtonSettings from "./component-settings/ButtonSettings";
import HeaderSettings from "./component-settings/HeaderSettings";
import LogoSettings from "./component-settings/LogoSettings";
import NavItemsSettings from "./component-settings/NavItemsSettings";
import SearchBarSettings from "./component-settings/SearchBarSettings";

interface SettingsPanelProps {
	selectedComponentId: string | null;
	setSelectedComponentId: (id: string | null) => void;
	state: HeaderState;
	dispatch: React.Dispatch<HeaderAction>;
}

const SettingsPanel: React.FC<SettingsPanelProps> = ({
	selectedComponentId,
	setSelectedComponentId,
	state,
	dispatch,
}) => {
	const selectedComponent = selectedComponentId
		? state.components.find((comp) => comp.id === selectedComponentId)
		: null;

	if (!selectedComponent) {
		return <HeaderSettings state={state} dispatch={dispatch} />;
	}

	const onBackClick = () => {
		setSelectedComponentId(null);
	};

	switch (selectedComponent.type) {
		case "logo":
			return (
				<LogoSettings
					component={selectedComponent}
					dispatch={dispatch}
					onBackClick={onBackClick}
				/>
			);
		case "searchBar":
			return (
				<SearchBarSettings
					component={selectedComponent}
					dispatch={dispatch}
					onBackClick={onBackClick}
				/>
			);
		case "navItems":
			return (
				<NavItemsSettings
					component={selectedComponent}
					dispatch={dispatch}
					onBackClick={onBackClick}
				/>
			);
		case "wishlist":
		case "cart":
		case "user":
		case "menu":
			return (
				<ButtonSettings
					component={selectedComponent}
					dispatch={dispatch}
					onBackClick={onBackClick}
				/>
			);
		default:
			return <div className="p-4">Select a component to edit</div>;
	}
};

export default SettingsPanel;
